import React from "react";

function Help() {
  return (
    <div>
      <svg
        width="48"
        height="64"
        viewBox="0 0 71 69"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse cx="35.5" cy="34.5" rx="35.5" ry="34.5" fill="#F89705" />
        <rect
          width="11.2811"
          height="10.8815"
          transform="matrix(0.999929 -0.0119229 0.0125719 0.999921 17.2537 40.4075)"
          fill="black"
        />
        <rect
          width="11.2811"
          height="10.8815"
          transform="matrix(0.999929 -0.0119229 0.0125719 0.999921 17.1422 26.989)"
          fill="black"
        />
        <rect
          width="11.2811"
          height="10.8815"
          transform="matrix(0.999934 -0.0115059 0.0131279 0.999914 17.0307 13.5706)"
          fill="black"
        />
        <rect
          width="11.2811"
          height="10.8815"
          transform="matrix(0.999929 -0.0119229 0.0125719 0.999921 31.418 40.2898)"
          fill="black"
        />
        <rect
          width="11.2811"
          height="10.8815"
          transform="matrix(0.999929 -0.0119229 0.0125719 0.999921 31.3065 26.8713)"
          fill="black"
        />
        <rect
          width="11.2811"
          height="10.8815"
          transform="matrix(0.999929 -0.0119229 0.0125719 0.999921 45.5826 40.2131)"
          fill="black"
        />
        <path
          d="M50.172 24.856H53.58V22.612C54.5 22.46 55.332 22.108 56.076 21.556C56.828 21.004 57.424 20.316 57.864 19.492C58.312 18.668 58.536 17.772 58.536 16.804C58.536 15.724 58.256 14.732 57.696 13.828C57.136 12.924 56.36 12.2 55.368 11.656C54.384 11.112 53.256 10.84 51.984 10.84C50.912 10.84 49.928 11.048 49.032 11.464C48.136 11.872 47.388 12.46 46.788 13.228C46.188 13.996 45.796 14.916 45.612 15.988L48.66 16.624C48.796 15.816 49.148 15.196 49.716 14.764C50.292 14.324 51.024 14.104 51.912 14.104C52.888 14.104 53.656 14.348 54.216 14.836C54.784 15.316 55.068 15.972 55.068 16.804C55.068 17.684 54.76 18.36 54.144 18.832C53.528 19.304 52.684 19.54 51.612 19.54C51.324 19.54 51.052 19.524 50.796 19.492C50.548 19.46 50.34 19.424 50.172 19.384V24.856ZM51.852 31.384C52.524 31.384 53.092 31.152 53.556 30.688C54.028 30.216 54.264 29.648 54.264 28.984C54.264 28.32 54.028 27.756 53.556 27.292C53.092 26.82 52.524 26.584 51.852 26.584C51.196 26.584 50.632 26.82 50.16 27.292C49.696 27.756 49.464 28.32 49.464 28.984C49.464 29.648 49.696 30.216 50.16 30.688C50.632 31.152 51.196 31.384 51.852 31.384Z"
          fill="black"
        />
      </svg>
    </div>
  );
}

export default Help;
